import HttpResponse from "../../../../../utils/http/http.response";

export enum ContractsCargoTaxiDetailsResponseItemModel {
  ABA = "ABA",
  SABS = "SABS",
  AB = "AB",
  OTHER = "OTHER",
}

export type ContractsCargoTaxiDetailsResponseItemCargoCompany = {
  displayName: string;
};

export type ContractsCargoTaxiDetailsResponseItem = {
  allowChargeWhileApproaching: boolean;
  allowChargeWhileReturning: boolean;
  allowChargeDuringRide: boolean;
  discountLimit: number;
  validSince: Date;
  validTo: Date;
  disabled: boolean;
  model: ContractsCargoTaxiDetailsResponseItemModel;
  distanceRate: number;
  haltingTimeRate: number;
  haltingTimeAfterMinutes: number;
  publishingAllowed: boolean;
  cargoCompany: ContractsCargoTaxiDetailsResponseItemCargoCompany;
  contactPassengerAfterMinutes: number;
  cancelByTaxiAllowed: boolean;
  editByTaxiAllowed: boolean;
};

type ContractsCargoTaxiDetailsResponse =
  HttpResponse<ContractsCargoTaxiDetailsResponseItem>;

export default ContractsCargoTaxiDetailsResponse;
